import { render } from "./Company-modal.vue?vue&type=template&id=4dcfdfbb&scoped=true"
import script from "./Company-modal.vue?vue&type=script&lang=js"
export * from "./Company-modal.vue?vue&type=script&lang=js"

import "./Company-modal.vue?vue&type=style&index=0&id=4dcfdfbb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcfdfbb"]])

export default __exports__